import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import FormGroup from './FormGroup';

export interface FormToggleGroupOption {
  id: string | number;
  label: string;
}

export interface FormToggleGroupProps {
  label?: string;
  error?: unknown;
  errorMessage?: string;
  required?: boolean;
  name?: string;
  control?: any;
  defaultValue?: string | number;
  disabled?: boolean;
  options?: FormToggleGroupOption[];
  helpContent?: React.ReactNode;
}

function FormToggleGroup({
  label,
  error,
  errorMessage,
  required,
  name,
  control,
  defaultValue,
  disabled,
  options = [],
  helpContent,
}: FormToggleGroupProps) {
  const [value, setValue] = useState<string | number | undefined>(defaultValue);

  return (
    <FormGroup
      label={label}
      error={Boolean(error)}
      errorMessage={errorMessage}
      required={required}
      helpContent={helpContent}
    >
      <Controller
        name={name ?? ''}
        control={control!}
        defaultValue={defaultValue}
        render={({ field: { onChange } }) => (
          <div className="toggle-group no-wrap">
            {options.map((option) => (
              <label
                key={String(option.id)}
                aria-label={label}
                className={`${value === option.id ? 'checked' : ''}`}
                tabIndex={0}
                onClick={() => {
                  onChange(option.id);
                  setValue(option.id);
                }}
                onKeyDown={(event: React.KeyboardEvent) => {
                  if (event.key === 'Enter') {
                    onChange(option.id);
                    setValue(option.id);
                  }
                }}
              >
                {option.label}
              </label>
            ))}
          </div>
        )}
      />
    </FormGroup>
  );
}

export default FormToggleGroup;
